import classNames from 'classnames';

import type { AspectRatioType } from './types';

import useStyles from './styles';

function AspectRatio({
  children,
  hostClassName,
  maxHeight,
  dimension,
  contentClassName,
}: AspectRatioType) {
  const styles = useStyles({ maxHeight, dimension });

  return (
    <div className={classNames(styles.root, hostClassName)}>
      <div className={classNames(styles.content, contentClassName)}>{children}</div>
    </div>
  );
}

export default AspectRatio;
